import script from "./tradeScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./tradeScreen.vue?vue&type=script&setup=true&lang=js"

import "./tradeScreen.vue?vue&type=style&index=0&id=0fb70130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb70130"]])

export default __exports__